import { Component, Vue, Prop } from 'vue-property-decorator';

@Component<Thumbnail>({})
export default class Thumbnail extends Vue {
  @Prop()
  protected thumbnailSrc!: string;

  @Prop()
  protected imageSrc!: string;

  protected openImage(): void {
    window.open(this.imageSrc);
  }
}
